import React from "react";
import { Col, Form, message, Modal, Row, Skeleton } from "antd";

import FormInput from "components/FormInput/FormInput";
import SectionCard from "components/SectionCard/SectionCard";
import Locale from "react-intl-universal";

const { useForm } = Form;

const ManageGoalModal = ({
  defaultValues = {},
  isLoading,
  onOk,
  onCancel,
  visible,
}) => {
  const [form] = useForm();

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  return (
    <Modal
      title={Locale.get("investmentPortfolio.goalManagement")}
      visible={visible}
      okText={Locale.get("investmentPortfolio.saveButton")}
      onOk={handleOnOkButtonClick}
      onCancel={onCancel}
      width="60%"
    >
      <Form form={form} initialValues={defaultValues}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <SectionCard title={Locale.get("investmentPortfolio.goalSetting")}>
            <Row gutter={16}>
              <Col span={24}>
                <FormInput
                  label={Locale.get("investmentPortfolio.goalDesc")}
                  name="description"
                  requiredErrorMessage={Locale.get(
                    "investmentPortfolio.errMsgGoalDesc"
                  )}
                />
              </Col>
              <Col span={16}>
                <FormInput
                  label={Locale.get("investmentPortfolio.goalAmount")}
                  name="goalAmt"
                  extraProps={{
                    type: "number",
                    // prefix: 'RM',
                    onPressEnter: handleOnOkButtonClick,
                  }}
                  requiredErrorMessage={Locale.get(
                    "investmentPortfolio.errMsgGoalAmount"
                  )}
                />
              </Col>
              <Col span={8}>
                <FormInput
                  label={Locale.get("investmentPortfolio.yearsToAchieve")}
                  name="yearsToAchieve"
                  extraProps={{
                    type: "number",
                    suffix: Locale.get("investmentPortfolio.yearSuffix"),
                    onPressEnter: handleOnOkButtonClick,
                  }}
                  requiredErrorMessage={Locale.get(
                    "investmentPortfolio.errMsgYearsToAchieve"
                  )}
                />
              </Col>
            </Row>
          </SectionCard>
        )}
      </Form>
    </Modal>
  );
};

export default ManageGoalModal;
